import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, ChildCordinatorActionId, countryActionId, ParentCordinatorActionId, toastError, toastSuccess, ArrangementTypeActionId, ScheduleTypeActionId } from "../../../../utils/constants";
import { emailValidator } from "../../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { insertUpdateInvitationType_action, getItineraryDetails_action, Verify_DelegateItineraryDateTimeSlot_action, getDelegateB2BCheckSchedule_action } from "../../../../actions/admin_module_action/delegate_master_action/delegate_Itinerary_action";
import Footer from "../../../../common_components/Footer";
import JoditEditor from "jodit-react";
import debounce from 'lodash/debounce';



class DelegateItineraryAU extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            countryList: [],
            DelegateItineraryList: [],
            deleteID: '',
            DelegateItineraryName: '',
            Status: '',
            isOpen2: false,
            isOpen3: false,
            is_add: false,
            is_Update: false,
            DelegateItineraryID: '',
            modalDelegateItineraryName: '',
            diplayStatus: 1,
            childCompanyNameID: '',
            childCompanyNameList: [],
            parentCompanyNameID: '',
            parentCompanyNameList: [],
            ArrangementTypeID: '',
            ArrangementTypeList: [],
            itineraryList: [
                {
                    ItineraryDate: '',
                    DelegateSeminarDetailsID: '',
                    B2BMeetingID: '',
                    InvitationinviteMappingID: '',
                    StartTime: '',
                    EndTime: '',
                    HtmlContent: '',
                    ArrangementTypeID: '',
                    MapUrl: '',
                    id: 1,
                }
            ],
            HtmlContent: '',
            inputMapUrl: '',
            mapUrl: '',
            contentIndex: '',
            mapUrlIndex: '',
            ExhibitionID: '',
            DelegateRegistrationID: '',
            is_add: false,
            IsCoordinator: false,
            IsDuplicatePresent: false,
            ScheduleTypeID: '',
            ScheduleTypeList: [],
            B2B_MeetingList: [],
            SeminarList: [],
            InvitationEvenList: [],
            verifyDelegateMsg: ''
        }
        this.checkTimeOverlap = this.checkTimeOverlap.bind(this)
    }

    componentDidMount() {
        this.getFillList(ParentCordinatorActionId, '', '', '', '', '')
        this.getFillList(ArrangementTypeActionId, '', '', '', '', '')
        this.getFillList(ScheduleTypeActionId, '', '', '', '', '')

        this.setState({
            ExhibitionID: this.props.location.state != null && this.props.location.state.ExhibitionID != null ? this.props.location.state.ExhibitionID : '',
            DelegateRegistrationID: this.props.location.state != null && this.props.location.state.DelegateRegistrationID != null ? this.props.location.state.DelegateRegistrationID : '',
            parentCompanyNameID: this.props.location.state != null && this.props.location.state.parentDelegateRegistrationID != null ? this.props.location.state.parentDelegateRegistrationID : '',
            childCompanyNameID: this.props.location.state != null && this.props.location.state.childDelegateRegistrationID != null ? this.props.location.state.childDelegateRegistrationID : '',
            is_add: this.props.location.state != null && this.props.location.state.is_add != null ? this.props.location.state.is_add : false,
            IsCoordinator: this.props.location.state != null && this.props.location.state.IsCoordinator != null ? this.props.location.state.IsCoordinator : false,
            is_Update: this.props.location.state != null && this.props.location.state.is_Update != null ? this.props.location.state.is_Update : false,
        }, () => {
            this.props.location.state != null && this.props.location.state.is_Update != null ? this.props.location.state.is_Update && this.getDelegateItineraryDetails('') : <></>
            if (this.state.IsCoordinator) {
                this.getFillList(ChildCordinatorActionId, '', this.state.DelegateRegistrationID, '', '', '')
            } else {
                this.getFillList(ChildCordinatorActionId, '', '', '', '', '')
            }
        })
        console.log("this.props", this.props)
    }

    buttons = [
        "undo",
        "redo",
        "|",
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "superscript",
        "subscript",
        "|",
        "align",
        "|",
        "ul",
        "ol",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "link",
        "table",
        "|",
        "hr",
        // "eraser",
        // "copyformat",
        "|",
        // "fullsize",
        // "selectall",
        "print",
        "|",
        // "source",
        "|",
        {
            name: "insertMergeField",
            tooltip: "Insert Merge Field",
            iconURL: "images/merge.png",
            popup: (editor, current, self, close) => {
                const onSelected = (e) => {
                    const mergeField = e.target.value;
                    if (mergeField) {
                        console.log(mergeField);
                        editor.selection.insertNode(
                            editor.create.inside.fromHTML("{{" + mergeField + "}}")
                        );
                    }
                };

                const divElement = editor.create.div("merge-field-popup");
                const labelElement = document.createElement("label");
                labelElement.setAttribute("class", "merge-field-label");
                labelElement.textContent = "Merge field: ";
                divElement.appendChild(labelElement);

                const selectElement = document.createElement("select");
                selectElement.setAttribute("class", "merge-field-select");
                selectElement.appendChild(
                    this.createOptionGroupElement(this.facilityMergeFields, "Facility")
                );
                selectElement.appendChild(
                    this.createOptionGroupElement(
                        this.inspectionMergeFields,
                        "Inspection"
                    )
                );
                selectElement.onchange = onSelected;
                divElement.appendChild(selectElement);

                console.log(divElement);
                return divElement;
            },
        },
        {
            name: "copyContent",
            tooltip: "Copy HTML to Clipboard",
            iconURL: "images/copy.png",
            exec: (editor) => {
                const html = editor.value;
                this.copyStringToClipboard(html);
            },
        },
    ];

    editorConfig = {
        readonly: false,
        toolbar: true,
        spellcheck: true,
        language: "en",
        toolbarButtonSize: "medium",
        toolbarAdaptive: false,
        showCharsCounter: true,
        showWordsCounter: true,
        showXPathInStatusbar: false,
        askBeforePasteHTML: true,
        askBeforePasteFromWord: true,
        buttons: this.buttons,
        uploader: {
            insertImageAsBase64URI: true,
        },
    };

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === ParentCordinatorActionId) {
                            this.setState({
                                parentCompanyNameList: data.data
                            })
                        }
                        if (actionID === ChildCordinatorActionId) {
                            this.setState({
                                childCompanyNameList: data.data
                            })
                        }
                        if (actionID === ArrangementTypeActionId) {
                            this.setState({
                                ArrangementTypeList: data.data
                            })
                        }
                        if (actionID === ScheduleTypeActionId) {
                            this.setState({
                                ScheduleTypeList: data.data
                            })
                        }
                        resolve(true)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    deleteExhNoteList(id) {
        const { itineraryList } = this.state
        const filterArray = itineraryList.filter(item => item.id != id)
        filterArray.map((item, i) => {
            item.id = i + 1
        })
        this.setState({ itineraryList: filterArray, IsDuplicatePresent: false })
    }

    getDelegateItineraryDetails() {
        this.setState({ isLoading: true })
        const { ExhibitionID, DelegateRegistrationID, childCompanyNameID } = this.state
        this.props.getItineraryDetails_action(ExhibitionID, childCompanyNameID != '' ? childCompanyNameID : DelegateRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.singledata != '') {
                        data.data.map((item, i) => {
                            item.ItineraryDate = new Date(item.Date)
                            item.StartTime = moment.utc(item.StartTime).format('HH:mm')
                            item.EndTime = moment.utc(item.EndTime).format('HH:mm')
                            item.id = i + 1
                        })
                        this.setState({ itineraryList: data.data })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    async insertDelegateItinerary() {
        const { itineraryList, ExhibitionID, DelegateRegistrationID, IsDuplicatePresent, childCompanyNameID, verifyDelegateMsg } = this.state
        var valid = true
        itineraryList.map((item) => {
            if (item.ItineraryDate == '' || item.StartTime == '' || item.EndTime == '' || item.ArrangementTypeID == '' || item.HtmlContent == '' || item.MapUrl == '') {
                valid = false
            } else {
                valid = true
            }
        })
        const validation = this.duplicatesCheckedValue(itineraryList, ['ItineraryDate', 'StartTime', 'EndTime'])
        const validation2 = await this.checkTimeOverlap(itineraryList)
        console.log('validation2', validation2)
        setTimeout(() => {
            if (valid) {
                if (!validation2) {
                    if (!IsDuplicatePresent && !validation && verifyDelegateMsg == '') {
                        this.setState({ isLoading: true })
                        this.props.insertUpdateInvitationType_action(ExhibitionID, childCompanyNameID != '' ? childCompanyNameID : DelegateRegistrationID, itineraryList)
                            .then((data) => {
                                if (data.error != 1) {
                                    toastSuccess("Update sucessfully")
                                    this.clearSearch()
                                    this.setState({ isLoading: false, isOpen2: false })
                                } else {
                                    this.setState({ isLoading: false })
                                    toastError(data.msg)
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        if (verifyDelegateMsg != '') {
                            toastError(verifyDelegateMsg)
                        } else {
                            toastError("Selected Date and Timeslot already exist!")
                        }
                        this.setState({ isLoading: false })
                    }
                } else {
                    toastError("The specified itinerary timings overlap. Please adjust the timings to avoid conflicts.")
                }
            } else {
                toastError("Please enter mandatory fields!")
                this.setState({ isLoading: false })
            }
        }, 100);
    }

    Verify_DelegateItineraryDateTimeSlot(ExhibitionID, DelegateRegistrationID, Date, StartTime, EndTime) {
        this.setState({ isLoading: true })
        this.props.Verify_DelegateItineraryDateTimeSlot_action(ExhibitionID, DelegateRegistrationID, Date, StartTime, EndTime)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, IsDuplicatePresent: false, verifyDelegateMsg: '' })
                }
                else {
                    this.setState({ isLoading: false, IsDuplicatePresent: true, verifyDelegateMsg: data.msg })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getDelegateB2BCheckSchedule() {
        const { childCompanyNameID, ScheduleTypeID } = this.state
        this.setState({ isLoading: true })
        const { ExhibitionID, DelegateRegistrationID } = this.state
        this.props.getDelegateB2BCheckSchedule_action(ExhibitionID, childCompanyNameID != '' ? childCompanyNameID : DelegateRegistrationID, ScheduleTypeID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        if (ScheduleTypeID == 1) {
                            this.setState({
                                B2B_MeetingList: data.B2B_Meeting,
                                SeminarList: data.Seminar,
                                InvitationEvenList: data.InvitationEven
                            })
                        } else if (ScheduleTypeID == 2) {
                            this.setState({
                                B2B_MeetingList: data.data,
                            })
                        } else if (ScheduleTypeID == 3) {
                            this.setState({
                                SeminarList: data.data,
                            })
                        } else if (ScheduleTypeID == 4) {
                            this.setState({
                                InvitationEvenList: data.data,
                            })
                        }
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { Stateno, PANNo } = this.state
        this.setState({
            DelegateItineraryName: '',
            Status: ''
        })
        // setTimeout(() => {
        //     this.getDelegateItineraryList()
        // }, 100);
    }

    deleteDelegateDelegateItinerary(id) {
        this.setState({ isLoading: true })
        this.props.deleteDelegateItinerary_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("Deleted successfully")
                    setTimeout(() => {
                        this.getDelegateItineraryList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(id) {
        const { } = this.state
        this.setState({ deleteID: id })
        this.setState({ isOpen: true, })
    }

    updateItem(item) {
        const { DelegateItineraryList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = DelegateItineraryList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(DelegateItineraryList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }


    addExhNoteList(i) {
        const { itineraryList } = this.state
        itineraryList.splice(
            i + 1, 0, {
            ItineraryDate: '',
            DelegateSeminarDetailsID: '',
            B2BMeetingID: '',
            InvitationinviteMappingID: '',
            StartTime: '',
            EndTime: '',
            HtmlContent: '',
            ArrangementTypeID: '',
            MapUrl: '',
            id: itineraryList.length + 1,
        }
        )
        this.setState({ itineraryList: itineraryList })
    }

    toggleModal(i, value) {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen, contentIndex: i, HtmlContent: value })
    }

    toggleModal2(i, value) {
        const { isOpen2 } = this.state
        this.setState({ isOpen2: !isOpen2, mapUrlIndex: i, inputMapUrl: value, mapUrl: value })
    }

    toggleModal3() {
        const { isOpen3 } = this.state
        this.setState({ isOpen3: !isOpen3 })
        this.getDelegateB2BCheckSchedule()
    }

    onInput(event, i, value) {
        const { itineraryList, DelegateRegistrationID, ExhibitionID, childCompanyNameID } = this.state
        console.log(event)
        itineraryList.map((data, index) => {
            if (i == index) {
                if (value == 'ItineraryDate') {
                    data.ItineraryDate = event
                } else if (value == 'StartTime') {
                    data.StartTime = event
                } else if (value == 'EndTime') {
                    data.EndTime = event
                } else if (value == 'ArrangementType') {
                    data.ArrangementTypeID = event
                } else if (value == 'HtmlContent') {
                    data.HtmlContent = event
                } else if (value == 'MapUrl') {
                    data.MapUrl = event
                }

                if (data.ItineraryDate != '' && data.StartTime != '' && data.EndTime != '') {
                    const validation = this.duplicatesCheckedValue(itineraryList, ['ItineraryDate', 'StartTime', 'EndTime'])
                    if (validation) {
                        toastError("Selected Date and Timeslot already exist!")
                    } else {
                        this.Verify_DelegateItineraryDateTimeSlot(ExhibitionID, childCompanyNameID != '' ? childCompanyNameID : DelegateRegistrationID, data.ItineraryDate, data.StartTime, data.EndTime)
                    }
                }
            }
        })
        this.setState({ itineraryList: itineraryList })
    }

    onPreviousClick() {
        this.props.navigate('/delegateItineraryList',)
    }

    checkTimeOverlap(itenaryArr) {
        return new Promise((resolve, reject) => {
            var isOverlapping = false
            console.log("oo", itenaryArr)
            for (var i = 0; i < itenaryArr.length; i++) {
                for (var j = 0; j < itenaryArr.length; j++) {
                    if (i != j) {
                        // console.log(new Date(itenaryArr[i].ItineraryDate).toISOString(), itenaryArr[j].ItineraryDate)
                        if (new Date(itenaryArr[i].ItineraryDate).toISOString() == new Date(itenaryArr[j].ItineraryDate).toISOString()) {
                            let today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
                            let start = new Date(`${today}T${itenaryArr[i].StartTime}:00`);
                            let end = new Date(`${today}T${itenaryArr[i].EndTime}:00`);
                            let newStartTime = new Date(`${today}T${itenaryArr[j].StartTime}:00`);
                            let newEndTime = new Date(`${today}T${itenaryArr[j].EndTime}:00`);
                            console.log(start, '//', newStartTime, '//', end, '//', newEndTime)
                            if (start == newStartTime) {
                                isOverlapping = true
                                break
                            }
                            else if (end == newEndTime) {
                                isOverlapping = true
                                break
                            }
                            else if ((start <= newStartTime) && (newStartTime <= end)) {
                                isOverlapping = true
                                break
                            }
                            else if ((start <= newEndTime) && (newEndTime <= end)) {
                                isOverlapping = true
                                break
                            }
                        }
                    }
                }
                if (isOverlapping) {
                    break
                }
            }
            resolve(isOverlapping)
            // return 
        })
    }

    duplicatesCheckedValue = (data, keys) => {
        const hasDuplicates = Object.values(
            data.reduce((acc, obj) => {
                const combinedKey = keys.map(key => obj[key]).join('|');
                acc[combinedKey] = (acc[combinedKey] || 0) + 1;
                return acc;
            }, {})
        ).some(value => value > 1);

        if (hasDuplicates) {
            this.setState({ IsDuplicatePresent: true })
        } else {
            this.setState({ IsDuplicatePresent: false })
        }

        return hasDuplicates;
    };

    record(list) {
        const { ArrangementTypeList } = this.state
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th style={{ width: '50px' }}>SR no.</th>
                        <th style={{ width: '220px' }}>Date<span className="text-red">*</span></th>
                        <th style={{ width: '200px' }}>Start Time<span className="text-red">*</span></th>
                        <th style={{ width: '200px' }}>End Time<span className="text-red">*</span></th>
                        <th style={{ width: '300px' }}>Type of Arrangement<span className="text-red">*</span></th>
                        <th style={{ width: '50px', textAlign: 'center' }}>HtmlContent<span className="text-red">*</span></th>
                        <th style={{ width: '50px', textAlign: 'center' }}>Google Map<span className="text-red">*</span></th>
                        <th style={{ width: '50px', textAlign: 'center' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr>
                                    <td className="text-center" style={{ verticalAlign: 'middle' }}>{data.id}</td>
                                    <td >
                                        <DatePicker selected={data.ItineraryDate}
                                            onChange={(date) => this.onInput(new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'ItineraryDate')}
                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            style={{ width: '100%' }}
                                            dropdownMode="select"
                                            placeholderText="DD/MM/YYYY"
                                            dayClassName={() => "example-datepicker-day-class"}
                                            popperClassName="example-datepicker-class" />
                                    </td>
                                    <td >
                                        <input
                                            type="time"
                                            className="form-control"
                                            value={data.StartTime}
                                            onChange={(e) => this.onInput(e.target.value, i, 'StartTime')}
                                        />
                                    </td>
                                    <td >
                                        <input
                                            type="time"
                                            className="form-control"
                                            value={data.EndTime}
                                            onChange={(e) => this.onInput(e.target.value, i, 'EndTime')}
                                        />
                                    </td>
                                    <td >
                                        <select className="form-control"
                                            value={data.ArrangementTypeID}
                                            onChange={(e) => this.onInput(e.target.value, i, 'ArrangementType')}
                                        >
                                            <option value={''}>Select</option>
                                            {
                                                ArrangementTypeList.length > 0 && ArrangementTypeList.map((data) => (
                                                    <option key={data.ArrangementTypeID} value={data.ArrangementTypeID}>{data.Name}</option>
                                                ))
                                            }
                                        </select>
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                        <button type="button"
                                            style={{ cursor: 'pointer' }} onClick={() => this.toggleModal(i, data.HtmlContent)}
                                            class="btn btn-aqua px-3">{data.HtmlContent == '' ? 'ADD' : 'UPDATE'}</button>
                                    </td>
                                    <td className="text-center" style={{ cursor: 'pointer', verticalAlign: 'middle' }} onClick={() => this.toggleModal2(i, data.MapUrl)}>
                                        <i class="fa fa-map-o" style={{ color: data.MapUrl != '' ? '#0d6efd' : '' }}></i>
                                    </td>
                                    <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                        <button
                                            title="Add Itinerary"
                                            class="btn btn-sm padding_0"
                                            onClick={() => this.addExhNoteList(i)}
                                        >
                                            <i class="fa fa-plus-square-o mx-2 mt-1 text-info"></i>
                                        </button>
                                        {this.state.itineraryList.length != 1 &&
                                            <button
                                                title="Delete Itinerary"
                                                class="btn btn-sm padding_0"
                                                onClick={() => this.deleteExhNoteList(data.id)}
                                            >
                                                <i class="fa fa-trash-o text-danger"></i>
                                            </button>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }

                </tbody>
            </table>)
    }

    submitContent() {
        const { itineraryList, contentIndex, HtmlContent } = this.state
        itineraryList.map((item, i) => {
            if (contentIndex == i) {
                item.HtmlContent = HtmlContent
            }
        })
        setTimeout(() => {
            this.setState({ itineraryList: itineraryList, HtmlContent: '', isOpen: false })
        }, 200);
    }

    submitMapUrl() {
        const { itineraryList, mapUrlIndex, mapUrl } = this.state
        itineraryList.map((item, i) => {
            if (mapUrlIndex == i) {
                item.MapUrl = mapUrl
            }
        })
        setTimeout(() => {
            this.setState({ itineraryList: itineraryList, inputMapUrl: '', isOpen2: false, mapUrl: '' })
        }, 200);
    }

    handleChangeContent = (newContent) => {
        this.setState({ HtmlContent: newContent });
    };

    render() {
        const { isLoading, parentCompanyNameID, parentCompanyNameList, childCompanyNameID, childCompanyNameList, ArrangementTypeID, ArrangementTypeList, itineraryList, isOpen, HtmlContent, isOpen2, mapUrl, inputMapUrl, contentIndex, mapUrlIndex, is_add, IsCoordinator, ScheduleTypeID, ScheduleTypeList, isOpen3 } = this.state
        console.log('itineraryList', itineraryList)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height" style={{ marginTop: '5rem' }}>
                        <AdminDrawer />
                        <div className="row" style={{ marginLeft: '0.3rem' }}>
                            <div className="step-name">
                                <p>{is_add ? 'Add' : 'Update'} Itinerary</p>
                            </div>
                        </div>
                        <div className="m-3">
                            <div className="">
                                <div className="row ">
                                    <div className="col-md-3">
                                        <label >Cordinator Company Name</label>
                                        <select className="form-control"
                                            value={parentCompanyNameID}
                                            onChange={(e) => this.setState({ parentCompanyNameID: e.target.value }, () => {
                                                e.target.value != '' ? this.getFillList(ChildCordinatorActionId, '', e.target.value, '', '', '') : this.setState({ childCompanyNameID: '', childCompanyNameList: [] })
                                            })}
                                            disabled
                                        >
                                            <option value={''}>Select</option>
                                            {
                                                parentCompanyNameList.length > 0 && parentCompanyNameList.map((data) => (
                                                    <option key={data.DelegateRegistrationID} value={data.DelegateRegistrationID}>{data.CompanyName}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    {!is_add &&
                                        <div className="col-md-3">
                                            <label >Sub Delegate</label>
                                            <select className="form-control"
                                                value={childCompanyNameID}
                                                onChange={(e) => this.setState({ childCompanyNameID: e.target.value }, () => {
                                                    this.getDelegateItineraryDetails()
                                                })}
                                                disabled={!IsCoordinator}
                                            >
                                                <option value={''}>Select</option>
                                                {
                                                    childCompanyNameList.length > 0 && childCompanyNameList.map((data) => (
                                                        <option key={data.DelegateRegistrationID} value={data.DelegateRegistrationID}>{data.CompanyName}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>}
                                    <div className="col-md-3">
                                        <label >Check Schedule</label>
                                        <select className="form-control"
                                            value={ScheduleTypeID}
                                            onChange={(e) => this.setState({ ScheduleTypeID: e.target.value })}
                                        >
                                            <option value={''}>Select</option>
                                            {
                                                ScheduleTypeList.length > 0 && ScheduleTypeList.map((data) => (
                                                    <option key={data.ScheduleTypeID} value={data.ScheduleTypeID}>{data.Name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3" style={{ textAlign: 'left' }}>
                                        <label >&emsp;</label>
                                        <button className="btn btn-aqua mx-2" onClick={e => this.toggleModal3()}
                                            disabled={ScheduleTypeID == ''}
                                        >
                                            Check
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 p-0 mt-4">
                                <div className="table-responsive">
                                    {this.record(itineraryList)}
                                </div>

                            </div>
                            < div className="row mt-2" >
                                <div className="col-md-12">
                                    <div className="main-container container-fluid p-0 mt-2 pt-0 pb-0">
                                        <div className="mt-1 mb-4">
                                            {this.state.is_add &&
                                                <button className="btn btn-outline-primary mx-2" onClick={e => this.insertDelegateItinerary()} >
                                                    Save
                                                </button>
                                            }
                                            {this.state.is_Update && <button className="btn btn-aqua mx-2" onClick={e => this.insertDelegateItinerary()} >
                                                Update
                                            </button>}
                                            <button className="btn btn-outline-secondary" onClick={e => this.onPreviousClick()}>
                                                {" "}
                                                Back{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal isOpen={isOpen} onRequestClose={(e) => this.toggleModal(e)}>
                        <div class="modal-dialog modal-xl">
                            <div class="modal-content w-auto">
                                <div class="modal-header py-2 pt-3">
                                    <h6 className="modal-title fw-semibold">
                                        <strong>Html Content</strong>
                                    </h6>
                                    <button
                                        type="button"
                                        className="btn-close pt-6"
                                        data-bs-dismiss="modal"
                                        style={{ fontSize: 12 }}
                                        aria-label="Close"
                                        onClick={(e) => this.toggleModal(e)}
                                    />
                                </div>
                                <div className="modal-body p-0">
                                    <div className="row mt-4 mb-4 m-2">
                                        <div className="col-md-12">
                                            <JoditEditor
                                                ref={this.editor}
                                                value={this.state.HtmlContent}
                                                config={this.editorConfig}
                                                onChange={this.handleChangeContent}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer p-1">
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.submitContent()}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.toggleModal(e)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </Modal>
                    <Modal size='lg' isOpen={isOpen2} onRequestClose={(e) => this.toggleModal2(e)}
                    >
                         <div class="modal-dialog modal-xl">
                            <div class="modal-content w-auto">
                                <div class="modal-header py-2 pt-3">
                                    <h6 className="modal-title fw-semibold">
                                        <strong>Google Map</strong>
                                    </h6>
                                    <button
                                        type="button"
                                        className="btn-close pt-6"
                                        data-bs-dismiss="modal"
                                        style={{ fontSize: 12 }}
                                        aria-label="Close"
                                        onClick={(e) => this.toggleModal2(e)}
                                    />
                                </div>
                                <div className="modal-body p-2" >
                                    <div className="row mt-4 mb-4 m-2">
                                        <div className="col-md-11" style={{ marginLeft: '-20px' }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={mapUrl}
                                                onChange={(e) => {
                                                    if (e.target.value != '') {
                                                        const event = e.target.value.replace('style="border:0;"', 'style={{ border: 0 }}')
                                                        this.setState({ mapUrl: event })
                                                    } else {
                                                        this.setState({ mapUrl: '' })
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-1">
                                            <button type="button" className="btn btn-outline-secondary ad-fil-btn"
                                                onClick={e => this.setState({ mapUrl: '' })}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                        <div className="col-md-12 mt-4" style={{ textAlign: 'center' }}>
                                            <div>
                                                <div dangerouslySetInnerHTML={{ __html: mapUrl }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer p-1">
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.submitMapUrl()}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.toggleModal2(e)}
                                    >
                                        Close
                                    </button>
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={isOpen3} onRequestClose={(e) => this.toggleModal3(e)}>
                        <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
                            <div className="modal-content shadow-lg border-0 rounded-4">
                                <div class="modal-header bg-aqua text-white py-2">
                                    <h5 className="modal-title" id="detailLabel">
                                        <strong>Checked Schedule</strong>
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close pt-6"
                                        data-bs-dismiss="modal"
                                        style={{ fontSize: 12 }}
                                        aria-label="Close"
                                        onClick={(e) => this.toggleModal3(e)}
                                    />
                                </div>
                                <div className="modal-body p-2">
                                    <div className="row mt-4 mb-4 m-2">
                                        {(ScheduleTypeID == 1 || ScheduleTypeID == 2) &&
                                            <div className="col-md-12">
                                                <div className="table-responsive">
                                                    <p className="m-0"><strong>B2B Meeting's Schedule:</strong></p>
                                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '500px' }}>Date</th>
                                                                <th style={{ width: '530px' }}>Start Time</th>
                                                                <th style={{ width: '530px' }}>End Time</th>
                                                                <th style={{ width: '500px' }}>Arrangement Type</th>
                                                                <th style={{ width: '500px' }}>Location</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.B2B_MeetingList.length > 0 ? <>{
                                                                    this.state.B2B_MeetingList.map((data, i) => (
                                                                        <tr key={Math.random()}>
                                                                            <td >{moment(data.Date).format('DD/MM/YYYY')}</td>
                                                                            <td >{moment.utc(data.StartTime).format('HH:mm')}</td>
                                                                            <td >{moment.utc(data.EndTime).format('HH:mm')}</td>
                                                                            <td >{data.ArrangementType}</td>
                                                                            <td >{data.Location != undefined && data.Location != null && data.Location != '' ? data.Location : '-'}</td>
                                                                        </tr>
                                                                    ))}
                                                                </> :
                                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>}
                                        {(ScheduleTypeID == 1 || ScheduleTypeID == 3) &&
                                            <div className="col-md-12 mt-3">
                                                <div className="table-responsive">
                                                    <p className="m-0"><strong>Seminar's Schedule:</strong></p>
                                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '500px' }}>Date</th>
                                                                <th style={{ width: '530px' }}>Start Time</th>
                                                                <th style={{ width: '530px' }}>End Time</th>
                                                                <th style={{ width: '500px' }}>Arrangement Type</th>
                                                                <th style={{ width: '500px' }}>Location</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.SeminarList.length > 0 ? <>{
                                                                    this.state.SeminarList.map((data, i) => (
                                                                        <tr key={Math.random()}>
                                                                            <td >{moment(data.Date).format('DD/MM/YYYY')}</td>
                                                                            <td >{moment.utc(data.StartTime).format('HH:mm')}</td>
                                                                            <td >{moment.utc(data.EndTime).format('HH:mm')}</td>
                                                                            <td >{data.ArrangementType}</td>
                                                                            <td >{data.Location != undefined && data.Location != null && data.Location != '' ? data.Location : '-'}</td>
                                                                        </tr>
                                                                    ))}
                                                                </> :
                                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>}
                                        {(ScheduleTypeID == 1 || ScheduleTypeID == 4) &&
                                            <div className="col-md-12 mt-3">
                                                <div className="table-responsive">
                                                    <p className="m-0"><strong>Invitation Event's Schedule:</strong></p>
                                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '500px' }}>Date</th>
                                                                <th style={{ width: '530px' }}>Start Time</th>
                                                                <th style={{ width: '530px' }}>End Time</th>
                                                                <th style={{ width: '500px' }}>Arrangement Type</th>
                                                                <th style={{ width: '500px' }}>Location</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.InvitationEvenList.length > 0 ? <>{
                                                                    this.state.InvitationEvenList.map((data, i) => (
                                                                        <tr key={Math.random()}>
                                                                            <td >{moment(data.Date).format('DD/MM/YYYY')}</td>
                                                                            <td >{moment.utc(data.StartTime).format('HH:mm')}</td>
                                                                            <td >{moment.utc(data.EndTime).format('HH:mm')}</td>
                                                                            <td >{data.ArrangementType}</td>
                                                                            <td >{data.Location != undefined && data.Location != null && data.Location != '' ? data.Location : '-'}</td>
                                                                        </tr>
                                                                    ))}
                                                                </> :
                                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                                <div className="modal-footer p-1">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.toggleModal3(e)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>
                {/* <Footer /> */}
            </>)
    }

}
export default withRouter(connect(null, { fill_action, insertUpdateInvitationType_action, getItineraryDetails_action, Verify_DelegateItineraryDateTimeSlot_action, getDelegateB2BCheckSchedule_action })(DelegateItineraryAU));